import * as firebase from 'firebase/app';
import 'firebase/firestore';

class StatusApi {
  constructor(firebaseConfig, state) {
    this.state = state;
    if (!firebase.apps.length && firebaseConfig) {
      const { firebaseOptions, ...restFirebaseConfig } = firebaseConfig;
      this.firebase = firebase.initializeApp(restFirebaseConfig);
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.firebase = firebase.apps[0];
    }
    if (firebaseConfig.firebaseOptions) {
      if (firebaseConfig.firebaseOptions.firestore) {
        this.db = this.firebase.firestore();
      }
    }
    this.table = 'status';
  }

  getAllFollowsLive(follows) {
    if (this.db) {
      const subscribe = this.db.collection(this.table).where('username', 'in', follows).orderBy('timestamp', 'asc');
      return subscribe;
    }
    throw (new Error('Firestore is not initialized'));
  }

  getAllByUsernameLive(username) {
    if (this.db) {
      const subscribe = this.db.collection(this.table).where('username', '==', username).orderBy('timestamp', 'asc');
      return subscribe;
    }
    throw (new Error('Firestore is not initialized'));
  }

  create(userId, status) {
    const p = new Promise((resolve, reject) => {
      if (this.db) {
        const userDocRef = this.db.collection('users').doc(userId);
        userDocRef.get().then((doc) => {
          if (doc.exists) {
            userDocRef.collection(this.table).add({
              message: status,
            }).then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    message: 'Status sent!',
                  },
                },
              });
            }).catch((error) => {
              reject(new Error(error.message));
            });
          } else {
            reject('User is not setup!');
          }
        }).catch((error) => {
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firestore is not initialized'));
      }
    });
    return p;
  }
}

export default StatusApi;
